import React from 'react';
import { Box, Divider, Link, Typography } from '@mui/material';
import PageHeader from '../components/PageHeader';

function ContactRow({ label, value, href }) {
  return (
    <Box sx={{ mb: 1 }}>
      <Typography variant="body2" color="text.secondary" component="span">
        {label}:{' '}
      </Typography>
      {href ? (
        <Link href={href} target="_blank" rel="noopener noreferrer" variant="body2">
          {value}
        </Link>
      ) : (
        <Typography variant="body2" component="span">{value}</Typography>
      )}
    </Box>
  );
}

export default function ContactsPage() {
  return (
    <>
    <PageHeader />
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 6, px: 3 }}>
      <Typography variant="h5" mb={3}>Контакты</Typography>
      <Typography variant="subtitle1" fontWeight={600} mb={2}>
        Центр развития «Intervision»
      </Typography>

      <Typography variant="subtitle2" color="text.secondary" mb={1}>Администратор</Typography>
      <Box sx={{ mb: 2, pl: 1 }}>
        <ContactRow label="Имя" value="Екатерина Пахомова" />
        <ContactRow label="Телефон" value="+7 923 708 70 67" href="tel:+79237087067" />
        <ContactRow label="Email" value="info.taunivers@gmail.com" href="mailto:info.taunivers@gmail.com" />
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Typography variant="subtitle2" color="text.secondary" mb={1}>Менеджер</Typography>
      <Box sx={{ mb: 2, pl: 1 }}>
        <ContactRow label="Имя" value="Елена Ождихина" />
        <ContactRow label="Телефон" value="+1 699 214 13 53" href="tel:+16992141353" />
        <ContactRow label="Email" value="info.taunivers@gmail.com" href="mailto:info.taunivers@gmail.com" />
        <ContactRow label="WhatsApp" value="+1 699 214 13 53" href="https://wa.me/16692141353" />
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Typography variant="subtitle2" color="text.secondary" mb={1}>Социальные сети</Typography>
      <Box sx={{ mb: 2, pl: 1 }}>
        <ContactRow label="WhatsApp" value="+7 923 708 70 67" href="https://wa.me/79237087067" />
        <ContactRow label="Facebook" value="facebook.com/intervision.me" href="https://facebook.com/intervision.me" />
        <ContactRow label="Instagram" value="instagram.com/intervision.me" href="https://instagram.com/intervision.me" />
      </Box>
    </Box>
    </>
  );
}
